import {
  GetFeiertagByStandortIdAndDatumQuery,
  GetFeiertagByStandortIdAndDatumQueryVariables,
} from '../gql/graphql';
import { useSuspenseQuery } from '@apollo/client';
import { GET_FEIERTAG_BY_STANDORT_ID_AND_DATUM } from './graphql';

export function useFeiertagByStandortIdAndDatum({
  standortId,
  datum,
}: {
  standortId: string;
  datum: string;
}): {
  feiertag?: string | null;
  error?: string;
} {
  const { data, error } = useSuspenseQuery<
    GetFeiertagByStandortIdAndDatumQuery,
    GetFeiertagByStandortIdAndDatumQueryVariables
  >(GET_FEIERTAG_BY_STANDORT_ID_AND_DATUM, {
    variables: { journaltag: datum, standortId },
  });

  if (!error) {
    return {
      feiertag: data.feiertagByStandortIdAndDatum
        ? data.feiertagByStandortIdAndDatum.name
        : null,
    };
  } else {
    return {
      error: error.message,
    };
  }
}
